module.exports = __webpack_public_path__ + "img/esg-rz-card.6585ed8f.png";